import _ from 'underscore';
import { SessionService } from '../../commonInfra/services/SessionService';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IRemoteRefreshAgentInfo } from '../models/IRemoteRefreshAgentInfo';
import { Module } from '../Module';
import { CompleteRemoteRefreshAgentWorkflowRequest } from '../ServerApi/requests/CompleteRemoteAgentWorkflowRequest';
import { GetRemoteRefreshAgentsRequest } from '../ServerApi/requests/GetRemoteRefreshAgentsRequest';
import { GetSiteRemoteAgentsConnectionStatusRequest, IGetSiteRemoteAgentsConnectionStatusResult, IRemoteAgentConnectionStatus } from '../ServerApi/requests/GetSiteRemoteAgentsConnectionStatusRequest';
import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';

export class RemoteRefreshAgents extends Resource<IRemoteRefreshAgentInfo> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {

    super(FetcherFactory.getServerResourceFetcher(
      GetRemoteRefreshAgentsRequest,
      ServerApiMapper.remoteRefreshAgents));

  }

  /**
   * Fire off a request *synchronously* (usually NOT what we want to do) and discard the result.
   *
   * This is useful to firing off a request in a window.unload event handler, as async requests
   * are usually aborted before the window closes. We use jQuery directly because Angular provides
   * no async:false mode in it's $http service.
   *
   * DO NOT USE this functionality unless you absolutely need synchronous AJAX, e.g. in a window.unload handler.
   */
  public fireAndForgetSynchronousRequest<TParams, TResult extends IResult>(request: IRequest<TParams, TResult>) {
    const url: string = WebHttpClient.API_PREFIX + request.method;

    const headers: { [key: string]: any } = {};
    headers[SessionService.getSessionCookieName()] = SessionService.getSessionId();

    const settings: JQueryAjaxSettings = {
      async: false,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(request),
      headers: headers
    };

    $.ajax(url, settings);
  }

  public get(): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetRemoteRefreshAgentsRequest({
      withContent: false
    }));
  }

  // Set the status of a workflow that a Remote Agent may be waiting for to "complete".
  // (Has the effect of stopping of Remote Agent from polling for workflow status.)
  public completeWorkflow(workflowId: string): ng.IPromise<IResult> {
    if (!_.isEmpty(workflowId)) {
      return WebHttpClientWithErrorToastInstance.sendRequest(new CompleteRemoteRefreshAgentWorkflowRequest({
        workflowId: workflowId
      }));
    }
  }

  // Set the status of a workflow that a Remote Agent may be waiting for to "complete".
  // (Has the effect of stopping of Remote Agent from polling for workflow status.)
  // Called synchronously.
  //
  // DO NOT REPLICATE this pattern unless you absolutely need synchronous AJAX.
  // It is useful, for instance, when you need something to fire off in a window.unload event handler.
  public completeWorkflowDuringWindowUnload(workflowId: string) {
    if (!_.isEmpty(workflowId)) {
      this.fireAndForgetSynchronousRequest(new CompleteRemoteRefreshAgentWorkflowRequest({
        workflowId: workflowId
      }));
    }
  }

  public getSiteRemoteAgentsConnectionStatus(): Promise<IRemoteAgentConnectionStatus[]> {
    return WebHttpClient.sendRequest(new GetSiteRemoteAgentsConnectionStatusRequest({}))
      .then(
        (result: IGetSiteRemoteAgentsConnectionStatusResult) => result.agents
      );
  }
}

Module.instance().service('RemoteRefreshAgents', RemoteRefreshAgents);
